import { render, staticRenderFns } from "./Facilities.vue?vue&type=template&id=c48d18b6&scoped=true&"
import script from "./Facilities.vue?vue&type=script&lang=ts&"
export * from "./Facilities.vue?vue&type=script&lang=ts&"
import style0 from "./Facilities.vue?vue&type=style&index=0&id=c48d18b6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c48d18b6",
  null
  
)

export default component.exports